import { useEffect, useState } from 'react'
import { GetCurrentUser } from '../Services/AccountService';
import { useConfig } from '../Providers/ConfigProvider';

const initialAuthState = {
    user: null,
    token: null,
    custId: null,
    siteId: null,
    whId: null,
    currency: 'PLN',
    selectedCustomer: null,
    selectedCustomerTax: null,
    selectedCustomerData: null,
    initialSiteId: null, //oddział do zamawiania
    initialWhId: null, //magazyn do zamawiania
}

const useHandleAuthState = () => {

    const { api } = useConfig()

    // Inicjalizacja stanu z localStorage jeśli jest zapisany
    const [authState, setAuthState] = useState(() => {
        const stored = localStorage.getItem('authState')
        return stored ? JSON.parse(stored) : initialAuthState
    })

    const [pending, setPending] = useState(true)
    const [refresh, setRefresh] = useState(false)

    // Zapisujemy każdą zmianę authState do localStorage
    useEffect(() => {
        localStorage.setItem('authState', JSON.stringify(authState))
    }, [authState])

    useEffect(() => {
        const token = localStorage.getItem('token')
        if (!token) {
            setPending(false)
            return
        }
        // Jeżeli już mamy usera z localStorage, nie pobieramy ponownie
        if (authState.user) {
            setPending(false)
            return
        }
        setPending(true)
        GetCurrentUser(api)
            .then((res) => {
                const newState = {
                    user: res.data,
                    token: token,
                    custId: res.data.custId,
                    siteId: res.data.siteId,
                    whId: res.data.whId,
                    currency: res.data.currency,
                    selectedCustomer: null,
                    selectedCustomerTax: null,
                    selectedCustomerData: null,
                    initialSiteId: res.data.siteId, //oddział do zamawiania
                    initialWhId: res.data.whId, //magazyn do zamawiania
                }
                setAuthState(newState)
            })
            .catch((e) => {
                console.error('Error fetching current user:', e)
            })
            .finally(() => setPending(false))
    }, [api])

    useEffect(() => {
        if (refresh) {
            setRefresh(false)
            setPending(true)
            const token = localStorage.getItem('token')
            if (!token) {
                setPending(false)
                return
            }
            GetCurrentUser(api)
                .then((res) => {
                    const newState = {
                        user: res.data,
                        token: token,
                        custId: res.data.custId,
                        siteId: res.data.siteId,
                        whId: res.data.whId,
                        currency: res.data.currency,
                        selectedCustomer: null,
                        selectedCustomerTax: null,
                        selectedCustomerData: null,
                        initialSiteId: res.data.siteId, //oddział do zamawiania
                        initialWhId: res.data.whId, //magazyn do zamawiania
                    }
                    setAuthState(newState)
                })
                .catch((err) => {
                    console.error('Error refreshing user:', err)
                })
                .finally(() => setPending(false))
        }
    }, [refresh, api])

    return { authState, pending, setAuthState, setPending, setRefresh }
}

export default useHandleAuthState

